export default "__VITE_ASSET__17c1c661__"